import { CardLeftGradient } from "@Components/game/cards/styled-components";
import { BybButtonVR } from "@Components/game/common";
import {
  PlaylistBannerCardBottomGradient,
  PlaylistBannerCardContent,
  PlaylistBannerCardRoot,
} from "@Components/game/playlists/highlighted/cards/styled-components";
import { Events } from "@Context/common/general/context";
import useI18n from "@i18n";
import { Box, Skeleton, Stack, Typography, useTheme } from "@mui/material";

interface IPlaylistBannerCard {
  id?: number;
  name?: string;
  description?: string;
  imageUrl?: string;
  loading?: boolean;
}

const PlaylistBannerCard = ({ id, name, description, imageUrl, loading = false }: IPlaylistBannerCard) => {
  const theme = useTheme();
  const { i18n } = useI18n();

  const handleClick = () => {
    Events.app.navigate.emit({ path: `/playlists/playlist/${id}` });
  };

  return (
    <PlaylistBannerCardRoot imageUrl={imageUrl}>
      <PlaylistBannerCardContent>
        {loading ? (
          <Stack spacing={1.5} paddingBottom={2}>
            <Skeleton width={400} height={100} animation="wave" />
            <Stack>
              <Skeleton width={600} height={25} animation="wave" />
              <Skeleton width={600} height={25} animation="wave" />
            </Stack>
          </Stack>
        ) : (
          <>
            <Typography variant="text8xl800" color="common.white" sx={{ marginBottom: theme.spacing(3) }}>
              {name}
            </Typography>
            <Typography variant="text1xl500" color="common.white" sx={{ marginBottom: theme.spacing(7.25) }}>
              {description}
            </Typography>
          </>
        )}
        <Box>
          <BybButtonVR onClick={handleClick} disabled={loading}>
            {i18n("playlists.view.playlist")}
          </BybButtonVR>
        </Box>
      </PlaylistBannerCardContent>
      <CardLeftGradient />
      <PlaylistBannerCardBottomGradient />
    </PlaylistBannerCardRoot>
  );
};

export default PlaylistBannerCard;
